/*

	YH: Data Spread Sheet is Here
	https://docs.google.com/spreadsheets/d/1GP-wc5RwVL54UcYqxjH_ZfCQWY7IAfuL_BSC2SXCL8s/edit?usp=sharing

*/

export const DummyPageBlog =
{
	id: 'blog',
	name: 'Blog',
	type: 'page',
	pattern: {
		index: 'c-page-blog-index-standard',
		detail: 'c-page-blog-detail-standard',
	},
	aspect: '',
};
